export type Site = {
  name: string;
  displayName: string;
  color: string;
};

export const sites: Site[] = [
  { name: 'mit', displayName: 'MIT', color: '#750014' },
  { name: 'mtsinai', displayName: 'Mt. Sinai', color: '#00467f' },
  { name: 'sickkids', displayName: 'SickKids', color: '#00B3E2' },
  { name: 'usf', displayName: 'USF', color: '#006747' },
  { name: 'vumc', displayName: 'VUMC', color: '#CFAE70' },
  { name: 'wcm', displayName: 'WCM', color: '#B31B1B' }
];

// Sites available for registration
export const registrationSiteNames: Site[] = sites.filter(x => ['mit', 'usf', 'vumc', 'wcm'].includes(x.name));

// All site display names
export const siteNames: string[] = sites.map(({ displayName }) => displayName);

// Map of site display names to colors
export const siteColorMap: Map<string, string> = new Map(sites.map(site => [site.displayName, site.color]));
